export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="pg-gold" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#F6D98B" />
        <stop offset="1" stopColor="#C98B1E" />
      </linearGradient>
    </defs>
    <rect x="2" y="2" width="60" height="60" rx="16" fill="#0A1226" />
    <rect x="2.5" y="2.5" width="59" height="59" rx="15.5" fill="none" stroke="#2B5BFF" strokeOpacity=".7" />
    <path d="M21 47V17h12.5a9.5 9.5 0 0 1 0 19H21" fill="none" stroke="url(#pg-gold)" strokeWidth="5.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M33 42.5h10.5v4.5" fill="none" stroke="#4C7DFF" strokeWidth="5.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Logo = ({ className = "" }) => (
  <span className={`flex items-center gap-3 ${className}`}>
    <LogoMark />
    <span className="leading-none">
      <span className="font-display block text-[17px] font-semibold tracking-[0.18em] text-white">PRATAP</span>
      <span className="block text-[10px] font-medium tracking-[0.42em] text-[var(--gold)]">GROUP</span>
    </span>
  </span>
);
